module.exports = __webpack_public_path__ + "static/img/Spencer-Leniu.0ef5c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Spencer-Leniu.jpg
// module id = oY1v
// module chunks = 0